module.exports = __webpack_public_path__ + "img/logo_white.b21d895b.png";